import { getRequest, postRequest, putRequest, deleteRequest } from "../api/apiService";

const API_URL = '/api/tags';

const getAllTags = () => {
    return getRequest(API_URL).then((response) => response.data);
};

const getTagsByUserId = (userId) => {
    if (!userId || userId === 'undefined') return Promise.resolve([]);
    return getRequest(`${API_URL}/user/${userId}`).then((response) => response.data);
};

const getTagById = (id) => {
    if (!id || id === 'undefined') return Promise.resolve(null);
    return getRequest(`${API_URL}/${id}`).then((response) => response.data);
};

const addTag = (tag) => {
    return postRequest(API_URL, tag).then((response) => response.data);
};

const updateTag = (id, tag) => {
    return putRequest(`${API_URL}/${id}`, tag).then((response) => response.data);
};

const deleteTag = (id) => {
    return deleteRequest(`${API_URL}/${id}`).then((response) => response.data);
};

const TagService = {
    getAllTags,
    getTagsByUserId,
    getTagById,
    addTag,
    updateTag,
    deleteTag,
};

export default TagService;
